module.exports = __webpack_public_path__ + "f671781b058c1bce43ba328bd74e3ac8.MP3";